import EventTreeVertex from '../EventTreeVertex';
import InitVertexValue from './InitVertexValue';
import {mxConstants, mxCylinder, mxGeometry, mxUtils} from "mxgraph-js";

class InitVertex extends EventTreeVertex {
  static SHAPE_KEY = 'esd-init-event';

  static getShape() {
    function InitVertexShape() { mxCylinder.call(this); }
    mxUtils.extend(InitVertexShape, mxCylinder);
    InitVertexShape.prototype.redrawPath = (c: any, x: any, y: any, w: any, h: any) => {
      const gateSize = InitVertex.SHAPE.GATE;
      const halfSize = InitVertex.SHAPE.GATE / 2;
      const radius = InitVertex.SHAPE.RADIUS;
      c.roundrect(0, 0, w, h - gateSize, radius, radius);
      c.close();
      c.fillAndStroke();
      c.ellipse(w * 0.5 - halfSize, h - gateSize + 2, gateSize, gateSize);
    };
    return InitVertexShape;
  }

  getType(): string {
    return "Initiating Event";
  }

  /**
   * @param {string} key
   * @param {InitVertexValue} value
   */
  constructor(key: string = 'init', value: InitVertexValue) {
    super(key, value);
  }

  /**
   * @override
   * @return {MxGraphType.mxGeometry}
   */
  getMyGeometry(): mxGeometry {
    return new mxGeometry(0, 0, InitVertex.SHAPE.WIDTH, InitVertex.SHAPE.HEIGHT);
  }

  /**
   * @override
   * @return {[index: string]: any}
   */
  getMyStyle(): {[index: string]: any} {
    const style: {[index: string]: any} = {};
    style[mxConstants.STYLE_ROUNDED] = 1;
    style[mxConstants.STYLE_SPACING] = 4;
    style[mxConstants.STYLE_FILLCOLOR] = 'rgba(209,207,214,0.2)';
    style[mxConstants.STYLE_STROKECOLOR] = 'rgba(131,135,151,0.75)';
    style[mxConstants.STYLE_FILL_OPACITY] = '50';
    style[mxConstants.STYLE_STROKE_OPACITY] = '100';
    style[mxConstants.STYLE_STROKEWIDTH] = '2';
    style[mxConstants.STYLE_FONTCOLOR] = 'inherit';
    style[mxConstants.STYLE_FONTSIZE] = '12';
    style[mxConstants.STYLE_SHAPE] = InitVertex.SHAPE_KEY;
    style[mxConstants.STYLE_SPACING_BOTTOM] = InitVertex.SHAPE.GATE;
    style[mxConstants.STYLE_WHITE_SPACE] = 'wrap';
    style[mxConstants.STYLE_AUTOSIZE] = 1;
    style[mxConstants.STYLE_RESIZABLE] = 0;
    style[mxConstants.STYLE_ASPECT] = 'fixed';
    style[mxConstants.STYLE_OVERFLOW] = 'hidden';
    return style;
  }

  clone(): InitVertex {
    return new InitVertex(null, this.value.clone());
  }
}

export default InitVertex;
